import { render, staticRenderFns } from "./blog-9.vue?vue&type=template&id=2be14bb2&scoped=true"
import script from "./blog-9.vue?vue&type=script&lang=js"
export * from "./blog-9.vue?vue&type=script&lang=js"
import style0 from "./blog-9.vue?vue&type=style&index=0&id=2be14bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be14bb2",
  null
  
)

export default component.exports